<!--
 * @Description: 收货信息
 * @Autor: txp
 * @Date: 2021-04-27 15:36:56
-->
<template>
  <div class="receivingInfo">
    <div>
      <el-form class="receivingInfo_cont" label-width="140px">
        <el-form-item class="mr40" label="订单类型：">
          <!-- <span class="ft16 C787878"></span> -->
          <el-select
            class="input-width"
            size="small"
            v-model="info.orderType"
            disabled=""
            placeholder="标准订单"
          >
            <el-option
              v-for="item in orderTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="mr40" label="客户名称：">
          <!-- <span class="ft16 C787878"></span> -->
          <el-input
            placeholder="收货人"
            class="input-width"
            size="small"
            disabled
            v-model="info.customerName"
          ></el-input>
        </el-form-item>
        <el-form-item class="mr40" label="所属集团：" required>
          <!-- <span class="ft16 C787878"></span> -->
          <el-input
            disabled
            placeholder="所属集团"
            class="input-width"
            size="small"
            v-model="info.companyName"
          ></el-input>
        </el-form-item>
        <el-form-item class="mr40 address" label="收货地址：" required>
          <!-- <span class="ft16 C787878"></span> -->
          <el-select
            style="width:670px;"
            size="small"
            v-model="info.destinationCode"
            @change="changeAddress"
            clearable
            placeholder="收货地址"
          >
            <el-option
              v-for="item in selectValList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="mr40" label="收货人：" required>
          <!-- <span class="ft16 C787878"></span> -->
          <el-input
            placeholder="收货人"
            class="input-width"
            size="small"
            v-model="info.contactName"
          ></el-input>
        </el-form-item>
        <el-form-item class="mr40" label="收货人电话：" required>
          <!-- <span class="ft16 C787878 "></span> -->
          <el-input
            placeholder="收货人电话"
            class="input-width"
            size="small"
            v-model="info.contactPhone"
          ></el-input>
        </el-form-item>

        <el-form-item class="mr40" label="配送方式：" required>
          <!-- <span class="ft16 C787878"></span> -->
          <el-select
            class="input-width"
            size="small"
            v-model="info.pickType"
            clearable
            placeholder="配送"
            @change="pickTypeChange"
          >
            <el-option
              v-for="item in pickTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 增加字段 -->
        <el-form-item class="mr40" label="期望到货时间：" required>
          <!-- <span class="ft16 C787878"></span> -->
          <el-date-picker
            v-model="info.giveDate"
            class="input-width"
            size="small"
            type="date"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item class="mr40" label="发票类型：" required>
          <!-- <span class="ft16 C787878"></span> -->
          <el-select
            disabled
            class="input-width"
            size="small"
            v-model="info.ext3"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in invoiceTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="mr40" label="供货方式：" required>
          <!-- <span class="ft16 C787878"></span> -->
          <el-select
            class="input-width"
            size="small"
            v-model="info.ext1"
            clearable
            placeholder="请选择"
            @change="(e) => getName(e, 'ext1', 'shippingMethodList')"
          >
            <el-option
              v-for="item in shippingMethodList.filter((item) => item.show)"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="mr40" label="运输方式：" required v-if="distributionType === 1">
          <!-- <span class="ft16 C787878"></span> -->
          <el-select
            class="input-width"
            size="small"
            v-model="info.ext2"
            clearable
            :disabled="ext2Disabled"
            placeholder="请选择"
            @change="(e) => getName(e, 'ext2', 'transportTypeList')"
          >
            <el-option
              v-for="item in transportTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          class="mr40"
          v-if="distributionType === 2"
          label="提货人姓名："
          :rules="[{ required: true, message: '提货人姓名', trigger: 'blur' }]"
        >
          <!-- <span class="ft16 C787878"></span> -->
          <el-input placeholder="提货人姓名" class="input-width" size="small" v-model="info.ext4" />
        </el-form-item>
        <el-form-item
          class="mr40"
          v-if="distributionType === 2"
          label="身份证号："
          :rules="[{ required: true, message: '身份证号', trigger: 'blur' }]"
        >
          <!-- <span class="ft16 C787878"></span> -->
          <el-input placeholder="身份证号" class="input-width" size="small" v-model="info.ext5" />
        </el-form-item>
        <el-form-item
          class="mr40"
          v-if="distributionType === 2"
          label="车牌号："
          :rules="[{ required: true, message: '车牌号', trigger: 'blur' }]"
        >
          <!-- <span class="ft16 C787878"></span> -->
          <el-input placeholder="车牌号" class="input-width" size="small" v-model="info.ext6" />
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { Storage } from '@/utils/storage'
import { dateFormat } from '@/utils/index'

import { ListCondition, getBatchDictSelect } from '@/api/api'
import { invoiceType } from '@/api/customer.js'
export default {
  name: 'receivingInfo',
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
          return time.getTime() < Date.now() //选当前时间之后的时间
          //return time.getTime() < Date.now()//选当前时间之后的时间
        }
      },
      info: {
        companyName: '矿泉水集团',
        // giveDate: dateFormat('YYYY-MM-dd', new Date().getTime()),
        giveData: '',
        orderType: '',
        contactName: '',
        contactPhone: '',
        pickType: '0', //配送方式
        picckTypeName: '配送',
        destinationCode: '',
        pickAdress: '',
        customerName: '',
        ext1: 'shipping_method_straight', //订单供货方式
        ext1Name: '工厂直发', //供货方式Name
        ext2: '', //订单运输方式
        ext2Name: '', //运输方式name
        ext3: '', //发票类型
        ext3Name: '', //发票类型name
        ext4: '', //提货人姓名
        ext5: '', //身份证号
        ext6: '', //车牌号
        ext40: '', //收货地址id
        ext37: '', //收货地址省名称
        ext38: '', //收货地址城市名称
        ext39: '' //收货地址地区名称
      },
      selectValList: [],
      orderTypeList: [],
      pickTypeList: [],
      shippingMethodList: [], //订单供货方式
      transportTypeList: [], //订单运输方式
      invoiceTypeList: [], //发票类型
      hdOrderStartShipQuantity: [], //起订量数据字典
      distributionType: 1, //配送方式1配送，2自提
      ext2Disabled: false //运输方式禁用
    }
  },
  props: {
    receivingInfo: Object
  },
  watch: {
    receivingInfo(v) {
      if (v.pickType === '0') {
        this.distributionType = 1
      } else {
        this.distributionType = 2
      }
      this.info = this.receivingInfo
      if (this.info.ext1) {
        this.getName(this.info.ext1, 'ext1', 'shippingMethodList')
      }
      if (this.info.ext2) {
        this.getName(this.info.ext2, 'ext2', 'transportTypeList')
      }
      if (this.info.ext3) {
        this.getName(this.info.ext3, 'ext3', 'invoiceTypeList')
      }
      if (this.info.pickType) {
        this.getName(this.info.pickType, 'pickType', 'pickTypeList')
      }
      this.getInvoiceType()
    }
  },
  mounted() {
    this.info.customerName = Storage.l.get('customerName')
    this.info.customerCode = Storage.l.get('customerCode')
    this.getBatchDictSelect()
    this.getAddress()
    this.getInvoiceType()
  },
  methods: {
    changeAddress(val) {
      if (val) {
        const address = this.selectValList.find((v) => v.id === val)
        this.info.contactName = address.contactName
        this.info.contactPhone = address.contactPhone
        this.info.pickAdress = address.detailedAddress
        this.info.ext40 = address.districtCode
        this.info.ext37 = address.provinceName
        this.info.ext38 = address.cityName
        this.info.ext39 = address.districtName
        // this.transportTypeList = this.transportTypeList.filter((item) =>
        //   (address.ext1 || '').split(',').includes(item.value)
        // )
        // this.info.ext2 =
        //   this.transportTypeList.length > 0 ? this.transportTypeList[0].value : undefined
        if (this.info.ext2) {
          this.getStartShipQuantity()
          // this.$emit(
          //   'getStartShipQuantity',
          //   this.hdOrderStartShipQuantity.find((item) => item.value === this.info.ext2).label
          // )
        }
      }
    },
    // 获取数据字典
    getBatchDictSelect() {
      const params = [
        'dms_order_type',
        'dms_order_pick_type',
        'dms_shipping_method',
        'dms_transport_type',
        'mdm_terminal_ka_bill_type',
        'hd_order_start_ship_quantity'
      ]
      getBatchDictSelect(params).then((res) => {
        if (res.success) {
          res.result.dms_order_type.forEach((v) => {
            this.orderTypeList.push({
              label: v.dictValue,
              value: v.dictCode
            })
            this.info.orderType = '1'
          })
          res.result.dms_order_pick_type.forEach((v) => {
            this.pickTypeList.push({
              label: v.dictValue,
              value: v.dictCode
            })
          })
          this.shippingMethodList = res.result.dms_shipping_method.map((v) => {
            return {
              label: v.dictValue,
              value: v.dictCode,
              show: true
            }
          })
          this.transportTypeList = res.result.dms_transport_type.map((v) => {
            return {
              label: v.dictValue,
              value: v.dictCode
            }
          })
          this.invoiceTypeList = res.result.mdm_terminal_ka_bill_type.map((v) => {
            return {
              label: v.dictValue,
              value: v.dictCode
            }
          })
          this.hdOrderStartShipQuantity = res.result.hd_order_start_ship_quantity.map((v) => {
            return {
              label: v.dictValue,
              value: v.dictCode
            }
          })

          if (this.info.ext1) {
            this.getName(this.info.ext1, 'ext1', 'shippingMethodList')
          }
          if (this.info.ext2) {
            this.getName(this.info.ext2, 'ext2', 'transportTypeList')
            // this.$emit(
            //   'getStartShipQuantity',
            //   this.hdOrderStartShipQuantity.find((item) => item.value === this.info.ext2).label
            // )
            this.getStartShipQuantity()
          }
          if (this.info.ext3) {
            this.getName(this.info.ext3, 'ext3', 'invoiceTypeList')
          }
          if (this.info.pickType) {
            this.getName(this.info.pickType, 'pickType', 'pickTypeList')
          }
          this.changeAddress(this.info.destinationCode)
        }
      })
    },
    // 获取收货地址
    getAddress() {
      const params = {
        customerCode: this.info.customerCode
      }
      ListCondition(params).then((res) => {
        if (res.success) {
          res.result.forEach((v) => {
            this.selectValList.push({
              ...v,
              label: v.detailedAddress,
              value: v.id
            })
          })
          this.info.destinationCode =
            res.result.find((item) => item.defaultAddress === '1') &&
            res.result.find((item) => item.defaultAddress === '1').id
          if (this.info.destinationCode) {
            this.changeAddress(this.info.destinationCode)
          } else {
            this.info.destinationCode = res.result[0].id
            this.changeAddress(this.info.destinationCode)
          }
        }
      })
    },
    // 获取发票类型
    async getInvoiceType() {
      const params = {
        customerCode: Storage.l.get('customerCode')
      }
      const res = await invoiceType(params)
      this.info.ext3 = res.result.ext11
      if (res.result.ext11) {
        this.info.ext3Name = this.invoiceTypeList.find((item) => item.value === res.result.ext11)
          ? this.invoiceTypeList.find((item) => item.value === res.result.ext11).label
          : ''
      }
      this.info = JSON.parse(JSON.stringify(this.info))
    },
    //获取起运量
    getStartShipQuantity() {
      if (this.info.ext1 === 'shipping_method_transit') {
        this.$emit(
          'getStartShipQuantity',
          this.hdOrderStartShipQuantity.find((item) => item.value === 'shipping_method_transit')
            ? this.hdOrderStartShipQuantity.find((item) => item.value === 'shipping_method_transit')
                .label
            : ''
        )
      } else {
        this.$emit(
          'getStartShipQuantity',
          this.hdOrderStartShipQuantity.find((item) => item.value === this.info.ext2)
            ? this.hdOrderStartShipQuantity.find((item) => item.value === this.info.ext2).label
            : ''
        )
      }
    },
    //获取下拉框选中项名称
    getName(val, field, data) {
      if (field === 'ext2') {
        this.getStartShipQuantity()
      }
      // 供货方式
      if (field === 'ext1') {
        this.getStartShipQuantity()
        if (val === 'shipping_method_transit' || val === 'shipping_method_transit_share') {
          this.ext2Disabled = true
          this.info.ext2 = 'transport_type_car'
        } else {
          this.ext2Disabled = false
          // this.info.ext2 = ''
        }
      }
      if (val) {
        this.info[`${field}Name`] = this[data].find((item) => item.value === val)
          ? this[data].find((item) => item.value === val).label
          : ''
      } else {
        this.info[`${field}Name`] = ''
      }
      // 如果选择的是中仓转站,且配送方式不为自提的情况，那么默认运输显示的就是汽运
      if (val == 'shipping_method_transit' && this.pickType != 1) {
        // this.$emit(
        //   'getStartShipQuantity',
        //   this.hdOrderStartShipQuantity.find((it) => it.value == 'transport_type_car').label
        //     ? this.hdOrderStartShipQuantity.find((it) => it.value == 'transport_type_car').label
        //     : 0
        // )
        this.getStartShipQuantity()
      }
    },
    //配送方式change事件
    pickTypeChange(e) {
      this.getName(e, 'pickType', 'pickTypeList')
      if (e === '0') {
        this.distributionType = 1
        this.shippingMethodList = this.shippingMethodList.map((item) => {
          item.show = true
          return item
        })
      } else {
        this.distributionType = 2
        this.shippingMethodList = this.shippingMethodList.map((item) => {
          if (item.value !== 'shipping_method_straight_spell') {
            item.show = true
          } else {
            item.show = false
          }
          return item
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-input.is-disabled .el-input__inner{
  color: #333 !important;
}
.receivingInfo {
  .input-width {
    width: 270px;
  }
  .el-input__inner {
    border-radius: 2px;
    // background: #F5F5F5;
  }
  .el-range-editor.el-input__inner {
    width: 236px;
  }
  // 选择框图标
  .el-icon-arrow-up:before {
    content: '\e790';
  }
  // 选择日期背景
  .el-range-input {
    background: #f5f5f5;
  }
  .receivingInfo_cont {
    display: flex;
    flex-wrap: wrap;
    .address {
      width: 760px;
    }
  }
  .receivingInfo_cont > div {
    margin-bottom: 6px;
    width: 360px;
    box-sizing: border-box;
  }
}
</style>
